export const GENERAL_USER = 'GENERAL_USER';
export const SUPERVISOR = 'SUPERVISOR';
export const SUPER_USER = 'SUPER_USER';
export const THIRD_STEP_USER = 'THIRD_STEP_USER';
export const THIRD_STEP_SUPERVISOR = 'THIRD_STEP_SUPERVISOR';
export const SSA_USER = 'EV_STAR';

export const ROLE_DISPLAY_NAME_MAP = {
  [SUPER_USER]: 'Super User',
  [SUPERVISOR]: 'Supervisor',
  [THIRD_STEP_USER]: 'Third Step User',
  [THIRD_STEP_SUPERVISOR]: 'Third Step Supervisor',
  [GENERAL_USER]: 'General User',
};

export const GENERAL_USER_DISPLAY_NAME_MAP = {
  LOC: 'General User 4',
  GRP: 'General User 3',
  USR: 'General User 2',
  NON: 'General User 1',
};

export const hasUserRole = (userRoles: string[], role: string): boolean => userRoles && userRoles.includes(role);

export const getUserRoleDisplayName = (userRoles: string[], verificationResponseCode: string) => {
  const userRole = userRoles.find((role) => !role.includes(SSA_USER));
  if (userRole.includes(GENERAL_USER)) {
    return GENERAL_USER_DISPLAY_NAME_MAP[verificationResponseCode];
  }
  return ROLE_DISPLAY_NAME_MAP[userRole];
};
